module.exports = __webpack_public_path__ + "media/svg/copy-squares-a4394fbf.svg";